import { ModuleWithProviders, NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { NgbDropdownModule, NgbModal, NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { NgxMaskModule } from 'ngx-mask';

import { DataTableModule } from 'angular-4-data-table-bootstrap-4';

import { SharedModule } from '../../shared.module';
import { UscStoreSchedulingComponent } from '../usc-store-scheduling/usc-store-scheduling.component';
import { UscAppointmentSchedulerComponent } from './usc-appointment-scheduler/usc-appointment-scheduler.component';
import { UscStoreSchedulingService } from '../../services/usc-store-scheduling/usc-store-scheduling-service';
import { UscSvtQueuePositionComponent } from './usc-svt-queue-position/usc-svt-queue-position.component';

const UscStoreSchedulingRouting: ModuleWithProviders = RouterModule.forChild([
    { path: 'usc-store-scheduler',                      component: UscAppointmentSchedulerComponent, }, 
    { path: 'usc-store-scheduler/appointments',         component: UscAppointmentSchedulerComponent, }, 
    { path: 'usc-store-scheduler/position-in-queue',    component: UscSvtQueuePositionComponent, }, 
]);

@NgModule({
    exports: [
    ],
    imports: [
        NgbDropdownModule.forRoot(),
        UscStoreSchedulingRouting,
        SharedModule,
        DataTableModule,
        NgxMaskModule.forRoot(),
    ],
    declarations: [
        UscStoreSchedulingComponent,
        UscAppointmentSchedulerComponent,
        UscSvtQueuePositionComponent,
    ],
    providers: [
        UscStoreSchedulingService,
        NgbModal,
        NgbActiveModal,
    ],
    // add components here for dynamic loading
    entryComponents: [
    ]
})

export class UscStoreSchedulingModule { }



// WEBPACK FOOTER //
// C:/Azure/Source/Workspaces/SalesNOW/SalesSOLO/WebSites/SalesSOLO.Web.Angular.telesales/src/app/components/usc-store-scheduling/usc-store-scheduling.module.ts